import { Box, Menu as MuiMenu } from 'src/components/mui';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
//@ts-ignore
import React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { TSelectOption } from '../types';
import { SxProps } from '@mui/material';

type Props = {
  value?: TSelectOption;
  placeholder?: string;
  items: TSelectOption[];
  onChange: (o: TSelectOption) => void;
  containerSx?: SxProps;
};

export function MenuSelect(props: Props) {
  const { placeholder = 'Select', items, containerSx, onChange } = props;

  const [value, setValue] = useState('');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    if (props?.value?.label) {
      setValue(props.value.label);
    }
  }, [props?.value?.label]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = useCallback(
    (o: TSelectOption) => () => {
      setValue(o.label);
      onChange(o);

      // Close menu
      setAnchorEl(null);
    },
    [onChange],
  );

  return (
    <Box sx={containerSx}>
      <Button
        sx={{
          color: 'white',
        }}
        onClick={handleClick}
      >
        {value || placeholder}
      </Button>
      <MuiMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          '&>.MuiPaper-root': {
            background: 'rgba(0, 0, 0, 0.4)',
            backdropFilter: 'blur(15px)',
          },
          '.MuiMenuItem-root': {
            color: 'white',
          },
        }}
      >
        {items.map((i) => (
          <MenuItem
            sx={{
              textTransform: 'capitalize',
            }}
            key={i.value}
            onClick={handleSelect(i)}
          >
            {i.label}
          </MenuItem>
        ))}
      </MuiMenu>
    </Box>
  );
}
